import { render, staticRenderFns } from "./AdvancePolicyForm.vue?vue&type=template&id=1a1931b2"
import script from "./AdvancePolicyForm.vue?vue&type=script&lang=js"
export * from "./AdvancePolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports